(function () {
  const SERVICE_LABELS = Object.freeze({ piercing: 'Ear piercing', permanent: 'Permanent jewelry', styling: 'Personal styling' });
  const LOCATION_LABELS = Object.freeze({ houston: 'Houston Heights', nashville: 'Nashville 12 South' });
  const GUEST_LABELS = Object.freeze({ adult: 'Adult, 18+', minor: 'Minor, ages 5-17' });
  const ALLOWED_SERVICES = new Set(Object.keys(SERVICE_LABELS));
  const ALLOWED_LOCATIONS = new Set(Object.keys(LOCATION_LABELS));
  const ALLOWED_GUESTS = new Set(Object.keys(GUEST_LABELS));
  const BOOKING_PRODUCTS = Object.freeze({
    piercing: {houston: 'piercing', nashville: 'piercing-nashville'},
    permanent: {houston: 'permanent-jewelry-appointment-houston', nashville: 'permanent-jewelry-appointment-nashville'},
    styling: {houston: 'stylist-appointment', nashville: 'stylist-appointment-nashville'}
  });

  function safeText(value, maxLength) {
    return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, maxLength) : '';
  }

  function validatePlan(payload) {
    const fields = payload && typeof payload.fields === 'object' ? payload.fields : {};
    return {
      service: ALLOWED_SERVICES.has(fields.service) ? fields.service : null,
      service_label: ALLOWED_SERVICES.has(fields.service) ? SERVICE_LABELS[fields.service] : null,
      piercing_count: Number.isInteger(fields.piercing_count) && fields.piercing_count >= 1 && fields.piercing_count <= 4 ? fields.piercing_count : null,
      guest: ALLOWED_GUESTS.has(fields.guest) ? fields.guest : null,
      guest_label: ALLOWED_GUESTS.has(fields.guest) ? GUEST_LABELS[fields.guest] : null,
      location: ALLOWED_LOCATIONS.has(fields.location) ? fields.location : null,
      location_label: ALLOWED_LOCATIONS.has(fields.location) ? LOCATION_LABELS[fields.location] : null,
      when: safeText(fields.when, 80) || null,
      style: safeText(fields.style, 80) || null,
      budget: Number.isInteger(fields.budget) && fields.budget >= 10 && fields.budget <= 10000 ? fields.budget : null
    };
  }

  function init(root) {
    if (root.dataset.bookingInitialized === 'true') return;
    root.dataset.bookingInitialized = 'true';

    const visitLink = root.querySelector('[data-visit-destination]');
    function updateVisit() {
      const service = root.querySelector('input[name="service"]:checked')?.value;
      const store = root.querySelector('input[name="location"]:checked')?.value;
      const handle = BOOKING_PRODUCTS[service]?.[store];
      const portrait = root.querySelector('.burd-appointments__portrait');
      const selectedPhoto = root.querySelector('input[name="service"]:checked')?.closest('label')?.querySelector('img');
      if (portrait && selectedPhoto) { portrait.src = selectedPhoto.src; portrait.alt = `Campaign concept: ${SERVICE_LABELS[service]}`; }
      const summary = root.querySelector('[data-visit-summary]');
      if (summary) summary.textContent = [SERVICE_LABELS[service] || 'Choose your service', LOCATION_LABELS[store] || 'Choose your store'].join(' · ');
      if (!visitLink) return;
      visitLink.setAttribute('aria-disabled', String(!handle));
      if (handle) visitLink.href = `${window.Shopify?.routes?.root || '/'}products/${handle}?booking_mode=manual&booking_store=${store}`;
      else visitLink.removeAttribute('href');
    }
    root.querySelectorAll('input[name="service"], input[name="location"]').forEach(input => input.addEventListener('change', updateVisit));
    updateVisit();
    visitLink?.addEventListener('click', event => {
      const service = root.querySelector('input[name="service"]:checked')?.value;
      const store = root.querySelector('input[name="location"]:checked')?.value;
      if (!BOOKING_PRODUCTS[service]?.[store]) {
        event.preventDefault();
        root.querySelector(`input[name="${service ? 'location' : 'service'}"]`)?.focus();
        return;
      }
      const concierge = root.querySelector('.burd-appointments__concierge');
      if (concierge && service === root.dataset.service && store === root.dataset.location) {
        event.preventDefault();
        openButtons[0].click();
      }
    });
    visitLink?.addEventListener('keydown', event => {
      if (event.key === 'Enter' && visitLink.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        visitLink.click();
      }
    });
    if (!root.querySelector('[data-booking-prompt-form]')) return;

    const isLocal = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
    const query = new URLSearchParams(window.location.search);
    const isDemo = isLocal && query.get('burdlife_booking_test') === '1';
    const endpoint = isLocal ? root.dataset.localPlanEndpoint : root.dataset.planEndpoint;
    const tabs = Array.from(root.querySelectorAll('[data-booking-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-booking-panel]'));
    const promptForm = root.querySelector('[data-booking-prompt-form]');
    const prompt = root.querySelector('[data-booking-prompt]');
    const submit = root.querySelector('[data-booking-submit]');
    const notice = root.querySelector('[data-booking-notice]');
    const noticeText = root.querySelector('[data-booking-notice-text]');
    const demoTimes = root.querySelector('[data-booking-demo-times]');
    const openButtons = Array.from(root.querySelectorAll('[data-open-servicify]'));
    const providerStatus = root.querySelector('[data-booking-provider-status]');
    const guestFieldset = root.querySelector('[data-booking-guest-fieldset]');
    let appButton = null;
    let providerObserver = null;
    let providerTimer = null;
    let providerTimedOut = false;
    const changeVisit = root.querySelector('[data-change-visit]');

    if (root.dataset.service !== 'piercing') {
      const piercingFaqSection = document.querySelector('[id$="__section_accordion_group_nB3cJ3"]');
      if (piercingFaqSection) piercingFaqSection.hidden = true;
    }

    function setMode(mode, focusPanel) {
      tabs.forEach((tab) => {
        const selected = tab.dataset.bookingTab === mode;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.bookingPanel !== mode; });
      if (focusPanel) root.querySelector(`[data-booking-panel="${mode}"] input, [data-booking-panel="${mode}"] textarea`)?.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        setMode(tab.dataset.bookingTab);
        if (tab.dataset.bookingTab === 'manual' && changeVisit) {
          changeVisit.open = true;
          root.querySelector('input[name="service"]:checked')?.focus();
        }
      });
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
        tabs[next].focus();
        setMode(tabs[next].dataset.bookingTab);
      });
    });

    function selectInput(name, value) {
      if (!value) return;
      const input = root.querySelector(`input[name="${name}"][value="${value}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function renderPlan(fields, completedCount) {
      const labels = {
        service: fields.service_label
          ? `${fields.service_label}${fields.piercing_count ? ` · ${fields.piercing_count} piercing${fields.piercing_count === 1 ? '' : 's'}` : ''}`
          : 'Not selected',
        guest: fields.guest_label || (fields.service && fields.service !== 'piercing' ? '1 guest' : 'Not selected'),
        location: fields.location_label || 'Not selected',
        when: fields.when || 'Not selected',
        style: [fields.style, fields.budget ? `under $${fields.budget}` : ''].filter(Boolean).join(' · ') || 'Optional'
      };
      Object.entries(labels).forEach(([key, value]) => {
        const target = root.querySelector(`[data-plan-field="${key}"]`);
        if (target) target.textContent = value;
      });
      selectInput('service', fields.service);
      selectInput('location', fields.location);
      selectInput('guest', fields.guest);
      if (guestFieldset) guestFieldset.hidden = fields.service !== 'piercing';
      const preferences = root.querySelector('[data-booking-preferences]');
      if (preferences) preferences.open = true;
      notice.classList.remove('is-error');
      noticeText.textContent = `Burdie filled ${determinedCount(fields)} details. Review anything before continuing.`;
      if (isDemo && demoTimes) demoTimes.hidden = false;
    }

    function determinedCount(fields) {
      return [fields.service, fields.piercing_count, fields.guest, fields.location, fields.when, fields.style || fields.budget]
        .filter((value) => value != null).length;
    }

    async function submitPrompt() {
      const message = prompt.value.trim();
      if (!message) {
        notice.classList.add('is-maintenance');
        noticeText.textContent = 'Choose your appointment details below.';
        setMode('manual', true);
        return;
      }
      submit.disabled = true;
      notice.classList.remove('is-maintenance');
      noticeText.textContent = 'Burdie is organizing your request…';
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message }),
          credentials: isLocal ? 'omit' : 'same-origin',
          signal: AbortSignal.timeout(3000)
        });
        if (!response.ok) throw new Error(response.status === 429 ? 'Too many requests. Try again in a few minutes.' : 'Burdie could not process that request.');
        const payload = await response.json();
        renderPlan(validatePlan(payload));
      } catch (error) {
        notice.classList.add('is-maintenance');
        noticeText.textContent = root.dataset.planUnavailable;
        setMode('manual', true);
      } finally {
        submit.disabled = false;
      }
    }

    promptForm.addEventListener('submit', (event) => { event.preventDefault(); submitPrompt(); });

    root.querySelectorAll('[data-edit-field]').forEach((button) => {
      button.addEventListener('click', () => {
        const name = button.dataset.editField;
        if (name === 'when') { openButtons[0].click(); return; }
        if (name === 'style') { setMode('ai', true); return; }
        if ((name === 'service' || name === 'location') && changeVisit) changeVisit.open = true;
        setMode('manual');
        root.querySelector(`input[name="${name}"]:checked, input[name="${name}"]`)?.focus();
      });
    });

    root.querySelectorAll('input[name="service"], input[name="location"], .burdlife-booking-workspace__manual input').forEach((input) => {
      input.addEventListener('change', () => {
        const target = root.querySelector(`[data-plan-field="${input.name}"]`);
        if (target) {
          const maps = { service: SERVICE_LABELS, location: LOCATION_LABELS, guest: GUEST_LABELS };
          target.textContent = maps[input.name]?.[input.value] || safeText(input.value, 80);
        }
        if (input.name === 'service' && guestFieldset) guestFieldset.hidden = input.value !== 'piercing';
      });
    });

    openButtons.forEach(button => { button.dataset.readyLabel = button.textContent; });

    function setProviderStatus(state) {
      root.dataset.providerState = state;
      openButtons.forEach(button => {
        button.disabled = state === 'loading';
        button.setAttribute('aria-busy', String(state === 'loading'));
        button.textContent = state === 'unavailable' ? (root.dataset.providerRetry || button.dataset.readyLabel) : button.dataset.readyLabel;
      });
      providerStatus.textContent = root.dataset[`provider${state[0].toUpperCase()}${state.slice(1)}`] || '';
    }

    function connectServicify() {
      const bookingSection = root.closest('.shopify-section');
      const sourceSection = bookingSection?.nextElementSibling;
      appButton = sourceSection?.querySelector('.servicify-select-a-time-button');
      if (!appButton || appButton.disabled) return false;
      // Keep the native product fallback visible unless the provider is usable.
      sourceSection.classList.add('burdlife-booking-source--hidden');
      sourceSection.setAttribute('aria-hidden', 'true');
      sourceSection.querySelectorAll('a, button, input, select, textarea').forEach((element) => { element.tabIndex = -1; });
      providerObserver?.disconnect();
      window.clearTimeout(providerTimer);
      setProviderStatus('ready');
      return true;
    }

    function waitForProvider() {
      if (connectServicify()) return;
      providerTimedOut = false;
      setProviderStatus('loading');
      providerObserver?.disconnect();
      window.clearTimeout(providerTimer);
      providerObserver = new MutationObserver(connectServicify);
      providerObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      providerTimer = window.setTimeout(() => {
        providerObserver.disconnect();
        if (connectServicify()) return;
        providerTimedOut = true;
        setProviderStatus('unavailable');
      }, 12000);
    }

    openButtons.forEach((openButton) => openButton.addEventListener('click', () => {
      const service = root.querySelector('input[name="service"]:checked')?.value || root.dataset.service;
      const location = root.querySelector('input[name="location"]:checked')?.value || root.dataset.location;
      if (service !== root.dataset.service || location !== root.dataset.location) {
        const handle = BOOKING_PRODUCTS[service]?.[location];
        if (!handle) return;
        const destination = new URL(`${window.Shopify?.routes?.root || '/'}products/${handle}`, window.location.origin);
        destination.searchParams.set('booking_mode', 'manual');
        destination.searchParams.set('booking_store', location);
        const guest = root.querySelector('input[name="guest"]:checked')?.value;
        if (ALLOWED_GUESTS.has(guest)) destination.searchParams.set('booking_guest', guest);
        window.location.assign(destination);
        return;
      }
      if (!connectServicify()) {
        if (providerTimedOut || root.dataset.providerState !== 'loading') waitForProvider();
        providerStatus.scrollIntoView({ block: 'nearest' });
        return;
      }
      appButton.click();
    }));

    root.querySelector('[data-booking-details]')?.addEventListener('submit', (event) => event.preventDefault());
    root.querySelector('[data-show-all-options]')?.addEventListener('click', () => {
      if (changeVisit) changeVisit.open = true;
      root.querySelector('input[name="service"]:checked')?.focus();
    });

    waitForProvider();
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      providerObserver?.disconnect();
      window.clearTimeout(providerTimer);
    });

    // The product route is authoritative; a stale query must not switch stores.
    const requestedGuest = query.get('booking_guest');
    if (ALLOWED_GUESTS.has(requestedGuest)) selectInput('guest', requestedGuest);
    if (query.get('booking_mode') === 'manual') setMode('manual');
    updateVisit();
    if (isDemo) window.setTimeout(submitPrompt, 250);
  }

  function boot(container) {
    (container || document).querySelectorAll('[data-burdlife-booking-workspace]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => boot());
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

/* ---------------------------------------------------------------------------
   BURDLIFE coming-soon gate, follow-up 2026-10-25.
   1) Auto-open: links from the gate add ?burdlife_open=1. When Servicify is
      ready, open its calendar once: through the booking workspace's own
      [data-open-servicify] button (it runs connectServicify first), or, on
      templates without the workspace, through Servicify's own rendered
      .servicify-select-a-time-button. Nothing is clicked unless it exists and
      is enabled. If Servicify is not ready within 15 s, the page stays as is.
   2) Skip the cart (gate on only): Servicify fires a 'cart:update' DOM event
      with detail.sourceId 'easy-appointment-bookings' and source 'add-to-cart'
      right after its own /cart/add.js succeeds. Then read /cart.js: go straight
      to checkout only when every line is part of this one booking (Servicify
      booking properties, same product and slot, or its booking upsells).
      Anything else (old items, another booking) goes to the cart page.
   3) After auto-open, burdlife_open is removed from the URL (replaceState),
      so a reload does not open the calendar again.
   This block may load twice (section + layout); the window flag guards it.
--------------------------------------------------------------------------- */
(function () {
  if (window.burdlifeGateBookingHelpers) return;
  window.burdlifeGateBookingHelpers = true;
  const root = window.Shopify?.routes?.root || '/';

  function autoOpen() {
    let query;
    try { query = new URLSearchParams(window.location.search); } catch (error) { return; }
    if (query.get('burdlife_open') !== '1' || !window.location.pathname.includes('/products/')) return;
    let done = false;
    let observer = null;
    let timer = null;
    function stop() { done = true; observer?.disconnect(); window.clearTimeout(timer); }
    function clearOpenParam() {
      try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('burdlife_open')) return;
        url.searchParams.delete('burdlife_open');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) { /* old browser: keep the URL */ }
    }
    function tryOpen() {
      if (done) return true;
      const workspace = document.querySelector('[data-burdlife-booking-workspace]');
      const workspaceButton = workspace?.querySelector('[data-open-servicify]');
      if (workspace && workspaceButton && workspace.dataset.providerState) {
        if (workspace.dataset.providerState === 'unavailable') { stop(); return true; }
        if (workspace.dataset.providerState !== 'ready' || workspaceButton.disabled) return false;
        stop();
        workspaceButton.click();
        clearOpenParam();
        return true;
      }
      const servicifyButton = Array.from(document.querySelectorAll('.servicify-select-a-time-button')).find((button) => !button.disabled);
      if (!servicifyButton) return false;
      stop();
      servicifyButton.click();
      clearOpenParam();
      return true;
    }
    if (tryOpen()) return;
    observer = new MutationObserver(tryOpen);
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-provider-state'] });
    timer = window.setTimeout(stop, 15000);
  }

  // Same booking-line test Servicify uses in its own cart code (embedInit.js), plus its booking upsells.
  const BOOKING_KEYS = ['_ID', '_Event #', 'Event #', '_Start Date', 'Start Date', 'Date'];
  function isBookingLine(item) {
    const props = item?.properties || {};
    return BOOKING_KEYS.some((key) => props[key] != null && props[key] !== '');
  }
  function isBookingUpsell(item) {
    const props = item?.properties || {};
    return props._upsell_for_booking != null && props._upsell_for_booking !== '';
  }
  function slotKey(item) {
    const props = item.properties || {};
    return [props['_Start Date'] || props['Start Date'] || props.Date || '', props['_Start Time'] || ''].join('|');
  }
  // true only when the cart holds this one booking and nothing else
  function cartIsOnlyThisBooking(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    if (!items.length) return false;
    const bookings = items.filter(isBookingLine);
    if (!bookings.length) return false;
    if (!items.every((item) => isBookingLine(item) || isBookingUpsell(item))) return false;
    const productId = window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id;
    if (productId && !bookings.every((item) => String(item.product_id) === String(productId))) return false;
    const slots = new Set(bookings.map(slotKey));
    return slots.size === 1;
  }
  window.burdlifeCartIsOnlyThisBooking = cartIsOnlyThisBooking; // for local tests

  let redirecting = false;
  document.addEventListener('cart:update', (event) => {
    const detail = event.detail || {};
    if (detail.sourceId !== 'easy-appointment-bookings' || detail.source !== 'add-to-cart') return;
    if (!document.body.classList.contains('burdlife-gate-on')) return;
    if (detail.cart && detail.cart.item_count === 0) return;
    if (redirecting) return;
    redirecting = true;
    // short pause so Servicify can finish its own add-to-cart log request
    window.setTimeout(async () => {
      let target = `${root}cart`;
      try {
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (response.ok && cartIsOnlyThisBooking(await response.json())) target = `${root}checkout`;
      } catch (error) { /* cart unknown: the cart page is the safe stop */ }
      window.location.assign(target);
    }, 350);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoOpen);
  else autoOpen();
})();

/* BURDLIFE gate: show the Servicify policy help text ("• a • b") as a green list.
   React owns the help text node, so we hide it and add our list next to it. */
(function () {
  if (!document.body || !document.body.classList.contains('burdlife-gate-on')) return;
  function listify() {
    document.querySelectorAll('[data-servicify="custom-field-helptext"]:not([data-burdlife-listed])').forEach(function (help) {
      var parts = help.textContent.split('•').map(function (s) { return s.trim(); }).filter(Boolean);
      if (parts.length < 2) return;
      var next = help.nextElementSibling;
      if (next && next.classList.contains('burdlife-policy-list')) next.remove();
      var ul = document.createElement('ul');
      ul.className = 'burdlife-policy-list';
      parts.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
      help.setAttribute('data-burdlife-listed', '');
      help.insertAdjacentElement('afterend', ul);
    });
  }
  new MutationObserver(listify).observe(document.body, { childList: true, subtree: true });
  listify();
})();

/* BURDLIFE gate: closing the Servicify calendar (its X button or Esc) goes back to the
   coming-soon start page instead of leaving people on the product page.
   Only the X button and Esc count: Servicify also closes the modal itself after add-to-cart,
   and that path must stay on the skip-cart redirect. */
(function () {
  if (window.burdlifeGateCloseHome) return;
  window.burdlifeGateCloseHome = true;
  function gateOn() { return document.body && document.body.classList.contains('burdlife-gate-on'); }
  function home() { window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'); }
  document.addEventListener('click', function (event) {
    if (!gateOn()) return;
    var target = event.target;
    if (target && target.closest && target.closest('.servicify-modal-close')) home();
  }, true);
  document.addEventListener('keydown', function (event) {
    if (!gateOn() || event.key !== 'Escape') return;
    if (document.querySelector('.servicify-modal-close')) home();
  }, true);
})();
